import React, { useEffect, useState } from 'react'
import { Col, Dropdown, Row, Table } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useImmer } from 'use-immer'
import ShimmeringEffect from '../../components/shimmering/ShimmeringEffect'
import { formatMRP } from '../../lib/AllGlobalFunction'
import { isSellerPanel } from '../../lib/AllStaticVariables'
import axiosProvider from '../../lib/AxiosProvider'
import { _kycImg_ } from '../../lib/ImagePath'

const TopSellingSellers = ({ values, setFieldValue }) => {
  const [loading, setLoading] = useState(false)
  const { userInfo } = useSelector((state) => state?.user)
  const [data, setData] = useImmer({
    topSellingSeller: []
  })

  const fetchData = async (days = 'All') => {
    try {
      setLoading(true)
      const response = await axiosProvider({
        method: 'GET',
        endpoint: 'Dashboard/getTopSellingSellers',
        queryString: `?days=${days}&sellerId=${
          isSellerPanel ? userInfo?.userId : ''
        }`
      })

      setLoading(false)

      if (response?.status === 200) {
        setData((draft) => {
          draft.topSellingSeller = response?.data?.data
        })
      }
    } catch {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  return loading ? (
    <ShimmeringEffect />
  ) : (
    <div
      style={{
        boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px'
      }}
      className='pv-dashbord-chart-col'
    >
      <Row className='w-100 m-auto py-3'>
        <Col md={12}>
          <div className='d-flex justify-content-between align-items-center'>
            <caption className='cfz-24'>Top Selling Seller</caption>

            <Dropdown>
              <Dropdown.Toggle className='btn-light' id='dropdown-basic'>
                {values?.topSellingSeller ? values?.topSellingSeller : 'All'}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item
                  onClick={() => {
                    fetchData('All')
                    setFieldValue('topSellingSeller', 'All')
                  }}
                >
                  All
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    fetchData('Today')
                    setFieldValue('topSellingSeller', 'Today')
                  }}
                >
                  Today
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    fetchData('7')
                    setFieldValue('topSellingSeller', 'Last Week')
                  }}
                >
                  Last Week
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    fetchData('15')
                    setFieldValue('topSellingSeller', 'Last 15 Days')
                  }}
                >
                  Last 15 Days
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    fetchData('30')
                    setFieldValue('topSellingSeller', 'This Month')
                  }}
                >
                  This Month
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    fetchData('90')
                    setFieldValue('topSellingSeller', 'Last 3 Month')
                  }}
                >
                  Last 3 Month
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </Col>
        <Col md={12}>
          <Table className='align-middle table-list mt-3'>
            <thead>
              <tr>
                <th>Product Details</th>
                <th>Total Orders</th>
                <th>Total Selling</th>
              </tr>
            </thead>
            <tbody>
              {data?.topSellingSeller?.length > 0 ? (
                data?.topSellingSeller?.map((data) => (
                  <tr key={data?.id}>
                    <td>
                      <div className='d-flex gap-4 align-items-center'>
                        <img
                          className='rounded-2 cw-80'
                          src={
                            data?.sellerLogo
                              ? `${process.env.REACT_APP_IMG_URL}${_kycImg_}${data?.sellerLogo}`
                              : 'https://placehold.jp/50x50.png'
                          }
                          alt='...'
                        />
                        <p className='mb-0'>{data?.sellerName}</p>
                      </div>
                    </td>
                    <td>{data?.totalOrders}</td>
                    <td>{formatMRP(data?.totalSell)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={4} className='text-center'>
                    No seller found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Col>
      </Row>
    </div>
  )
}

export default TopSellingSellers
